import getConfig from 'next/config';
import { AppLocationEnum } from 'types/app';

export default function useAppLocation() {
  const { publicRuntimeConfig } = getConfig();
  const { location } = publicRuntimeConfig;

  return location as AppLocationEnum;
}
